import {
  Route,
} from "react-router-dom";


const FadingRoute = ({ component: Component, ...props }) => {
  return (
    <Route
      {...props}
      render={routeProps => (
          <Component {...routeProps} />
      )}
    />
  );
}


export {FadingRoute}
